import { Link } from 'react-router-dom';

export default function Footer() {
  const productCategories = [
    { name: 'Vegetables', path: '/products?category=Vegetables' },
    { name: 'Fruits', path: '/products?category=Fruits' },
    { name: 'Legumes', path: '/products?category=Legumes' },
  ];

  return (
    <footer className="relative overflow-hidden text-white">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-900 via-emerald-800 to-teal-900 bg-[length:400%_400%] animate-gradient-move"></div>
      
      {/* Decorative Floating Elements */}
      <div className="absolute top-20 left-10 w-40 h-40 bg-emerald-500/10 rounded-full blur-3xl animate-float"></div>
      <div className="absolute bottom-20 right-10 w-60 h-60 bg-teal-500/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
      <div className="absolute top-1/2 left-1/3 w-32 h-32 bg-emerald-400/10 rounded-full blur-2xl animate-float" style={{ animationDelay: '1s' }}></div>

      {/* Main Footer Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src="/logo/logo-en-2.png"
              alt="Al-Amein Logo"
              className="h-12 md:h-14 w-auto mb-4 md:mb-6 brightness-0 invert"
            />
            <p className="text-emerald-100/80 text-sm leading-relaxed mb-4 md:mb-6">
              Leading Egyptian agricultural export company, delivering premium fresh produce to global markets since 1998.
            </p>
            <div className="flex gap-3">
              <a
                href="https://web.facebook.com/profile.php?id=100091249341012"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-xl relative overflow-hidden cursor-pointer group bg-white/10 backdrop-blur-md border border-white/20"
              >
                <span className="absolute inset-0 bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-400 bg-[length:200%_100%] animate-gradient-move opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                <i className="ri-facebook-fill relative z-10"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/al-amein-for-import-export-and-agricultural-investement/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-xl relative overflow-hidden cursor-pointer group bg-white/10 backdrop-blur-md border border-white/20"
              >
                <span className="absolute inset-0 bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-400 bg-[length:200%_100%] animate-gradient-move opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                <i className="ri-linkedin-fill relative z-10"></i>
              </a>
              <a
                href="https://wa.me/201069539609"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-xl relative overflow-hidden cursor-pointer group bg-white/10 backdrop-blur-md border border-white/20"
              >
                <span className="absolute inset-0 bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-400 bg-[length:200%_100%] animate-gradient-move opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                <i className="ri-whatsapp-line relative z-10"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="text-base md:text-lg font-semibold mb-4 md:mb-6 relative inline-block">
              Quick Links
              <span className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-emerald-400 to-teal-400"></span>
            </h5>
            <ul className="space-y-2 md:space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'About Us', path: '/about' },
                { name: 'Our Products', path: '/products' },
                { name: 'Gallery', path: '/gallery' },
                { name: 'Contact Us', path: '/contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-emerald-100/70 hover:text-white hover:pl-2 transition-all duration-300 text-sm flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-emerald-400"></i>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Product Categories */}
          <div>
            <h5 className="text-base md:text-lg font-semibold mb-4 md:mb-6 relative inline-block">
              Our Products
              <span className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-emerald-400 to-teal-400"></span>
            </h5>
            <ul className="space-y-2 md:space-y-3">
              {productCategories.map((category) => (
                <li key={category.name}>
                  <Link
                    to={category.path}
                    className="text-emerald-100/70 hover:text-white hover:pl-2 transition-all duration-300 text-sm flex items-center gap-2"
                  >
                    <i className="ri-leaf-line text-emerald-400"></i>
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h5 className="text-base md:text-lg font-semibold mb-4 md:mb-6 relative inline-block">
              Contact Us
              <span className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-emerald-400 to-teal-400"></span>
            </h5>
            <ul className="space-y-3 md:space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 relative overflow-hidden bg-white/10 backdrop-blur-md border border-white/20">
                  <span className="absolute inset-0 bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-400 bg-[length:200%_100%] animate-gradient-move opacity-30"></span>
                  <i className="ri-map-pin-line text-emerald-400 relative z-10"></i>
                </div>
                <div>
                  <p className="text-xs md:text-sm text-emerald-100/70">Tanta, Al-Bahr Street, Town Mall, 6th Floor</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 relative overflow-hidden bg-white/10 backdrop-blur-md border border-white/20">
                  <span className="absolute inset-0 bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-400 bg-[length:200%_100%] animate-gradient-move opacity-30"></span>
                  <i className="ri-phone-line text-emerald-400 relative z-10"></i>
                </div>
                <div>
                  <a
                    href="tel:+201069539609"
                    className="text-xs md:text-sm text-emerald-100/70 hover:text-white transition-colors block"
                  >
                    +20 106 953 9609
                  </a>
                  <a
                    href="tel:+201066880880"
                    className="text-xs md:text-sm text-emerald-100/70 hover:text-white transition-colors block"
                  >
                    +20 106 688 0880
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 relative overflow-hidden bg-white/10 backdrop-blur-md border border-white/20">
                  <span className="absolute inset-0 bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-400 bg-[length:200%_100%] animate-gradient-move opacity-30"></span>
                  <i className="ri-mail-line text-emerald-400 relative z-10"></i>
                </div>
                <div className="space-y-1">
                  <a
                    href="mailto:info@al-amein.com"
                    className="text-xs md:text-sm text-emerald-100/70 hover:text-white transition-colors block"
                  >
                    info@al-amein.com
                  </a>
                  <a
                    href="mailto:sales@al-amein.com"
                    className="text-xs md:text-sm text-emerald-100/70 hover:text-white transition-colors block"
                  >
                    sales@al-amein.com
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative z-10 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-2 text-white/60 text-xs md:text-sm">
            <p>&copy; 2026 Al-Amein. All rights reserved.</p>
            <p>
              Designed by{' '}
              <a
                href="https://bp-eg.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-emerald-400 hover:text-white transition-colors"
              >
                Business Partner for Information Technology
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
